import { createUseStyles } from 'react-jss';

import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexBasis: '100%',
      position: 'relative',
    },

    search: {
      paddingLeft: 44,
      paddingRight: 44,
    },

    icon: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      top: 0,
      bottom: 0,
      color: colors.iconTertiary,
    },

    iconDisabled: {
      pointerEvents: 'none',
      color: colors.iconDisabled,
    },

    searchIcon: {
      left: spacing.sp04,
      transition: 'all .3s ease-out',

      '&:hover': {
        color: colors.iconPrimary,
      },
    },

    clearIcon: {
      right: spacing.sp04,
      color: colors.iconPrimary,
    },
  },
  {
    name: 'InputSearch',
  },
);
